  
import { BEFORE_NFT, GET_NFTS, GET_NFT, UPSERT_NFT, SEARCH_NFT } from '../../redux/types';

const initialState = {
    nftsData: {},
    nftsAuth: false,
    upsertAuth: false,
    searchAuth: false,
    searchData: null
}

export default function nftsRed(state = initialState, action) {
    switch (action.type) {
        case UPSERT_NFT:
            return {
                ...state,
                nftsData: action.payload,
                upsertAuth: true
            }
        case SEARCH_NFT:
            return {
                ...state,
                searchData: action.payload,
                searchAuth: true
            }
        case GET_NFT:
            return {
                ...state,
                nftsData: action.payload,
                nftsAuth: true
            }
        case GET_NFTS:
            return {
                ...state,
                nftsData: action.payload,
                nftsAuth: true
            }
        case BEFORE_NFT:
            return {
                ...state,
                nftsData: {},
                nftsAuth: false,
                upsertAuth: false,
                searchAuth: false,
                searchData: null
            }
        default:
            return {
                ...state
            }
    }
}

// import { BEFORE_NFT, GET_NFTS, GET_NFT, UPSERT_NFT, SEARCH_NFT } from '../../redux/types';

// const initialState = {
//     nftsData: { nfts: [], pagination: null},
//     nftsAuth: false,
//     upsertAuth: false,
//     searchAuth: false,
//     searchData: null
// }

// export default function (state = initialState, action) {
//     switch (action.type) {
//         case UPSERT_NFT:
//             return {
//                 ...state,
//                 nftsData: action.payload,
//                 upsertAuth: true
//             }
//         case SEARCH_NFT:
//             return {
//                 ...state,
//                 searchData: action.payload,
//                 searchAuth: true
//             }
//         case GET_NFT:
//             return {
//                 ...state,
//                 nftsData: action.payload,
//                 nftsAuth: true
//             }
//         case GET_NFTS:
//             console.log('Get NFts', state.nftsData)
//             let nfts =[...state.nftsData.nfts,...action.payload.nfts]

//             return {
//                 ...state,
//                 nftsData: {
//                     nfts:[...nfts],
//                     pagination: action.payload.pagination 
//                 },
//                 nftsAuth: true


//             }
//         case BEFORE_NFT:
//             return {
//                 ...state,
//                 nftsData: {nfts: [], pagination: null},
//                 nftsAuth: false,
//                 upsertAuth: false,
//                 searchAuth: false,
//                 searchData: null
//             }
//         default:
//             return {
//                 ...state
//             }
//     }
// }